export default __webpack_public_path__ + "static/media/planeAsset 4.d974202c.svg";